// extracted by mini-css-extract-plugin
export default {"root":"Contact_root__yXBR3","inputbox":"Contact_inputbox__4t3KH"};